import { Form } from '@ant-design/compatible'

import ManageActiveSubstanceFamilyForm from './ManageActiveSubstanceFamilyForm'

export default Form.create({
  name: 'activeSubstanceFamilyForm',
})(ManageActiveSubstanceFamilyForm)
